import React, { useState } from "react";
import { DollarSign, TrendingUp, Calendar, MessageCircle, Plus, X } from "lucide-react";
import { ChatInterface } from "../chat";
import { LabeledFabAction } from "@/components/molecules/LabeledFabAction";
import { ProUpgradeModal } from "@/components/molecules/ProUpgradeFunnel";
import { useProAccess } from "@/hooks/useProAccess";
import type { TimelineSnapshot } from "../../types/burndown.types";

interface MobileActionButtonsProps {
  onAddExpense: () => void;
  onAddRevenue: () => void;
  onAddEvent: () => void;
  startupId: string;
  currentSnapshot?: TimelineSnapshot | null;
}

export const MobileActionButtons: React.FC<MobileActionButtonsProps> = ({
  onAddExpense,
  onAddRevenue,
  onAddEvent,
  startupId,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isProPaywallOpen, setIsProPaywallOpen] = useState(false);
  const { isPro } = useProAccess();

  return (
    <>
      <div className="fixed bottom-6 right-4 z-50 flex flex-col items-end lg:hidden">
        {isExpanded ? (
          <div className="mb-3 flex flex-col items-end gap-3">
            <LabeledFabAction
              label="AI advisor"
              icon={MessageCircle}
              tone="brand"
              badge={!isPro ? "Pro" : undefined}
              onClick={() => {
                if (isPro) {
                  setIsChatOpen(!isChatOpen);
                } else {
                  setIsProPaywallOpen(true);
                }
                setIsExpanded(false);
              }}
            />
            <LabeledFabAction
              label="Add expense"
              icon={DollarSign}
              tone="expense"
              onClick={() => {
                onAddExpense();
                setIsExpanded(false);
              }}
            />
            <LabeledFabAction
              label="Add revenue"
              icon={TrendingUp}
              tone="revenue"
              onClick={() => {
                onAddRevenue();
                setIsExpanded(false);
              }}
            />
            <LabeledFabAction
              label="Add event"
              icon={Calendar}
              tone="focus"
              onClick={() => {
                onAddEvent();
                setIsExpanded(false);
              }}
            />
          </div>
        ) : null}

        <button
          type="button"
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-brand text-surface shadow-glow ring-2 ring-brand/30 transition-colors hover:bg-brand-muted"
          title={isExpanded ? "Close menu" : "Add item"}
          aria-expanded={isExpanded}
        >
          {isExpanded ? (
            <X className="h-6 w-6" />
          ) : (
            <Plus className="h-6 w-6" />
          )}
        </button>
      </div>

      <ChatInterface
        startupId={startupId}
        isOpen={isChatOpen && isPro}
        onClose={() => setIsChatOpen(false)}
      />

      <ProUpgradeModal
        isOpen={isProPaywallOpen}
        onClose={() => setIsProPaywallOpen(false)}
        featureId="ai_advisor"
        showFeatureGrid={false}
      />
    </>
  );
};
